var _path, _circle, _circle2, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExhaustFan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.68 48",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "exhaustfan"
  }, "Kitchen Exhaust Fan Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "exhaustfan"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.83,22a.71.71,0,0,0-.22-.33L29.94,11.38A1.85,1.85,0,0,0,30,10.9V1.7A1.75,1.75,0,0,0,28.26,0H15.06A1.75,1.75,0,0,0,13.31,1.7v9.2a1.5,1.5,0,0,0,0,.37l-13,10.8h0a1.74,1.74,0,0,0-.55,1.27v6.54a1.75,1.75,0,0,0,1.75,1.75H41.73a1.75,1.75,0,0,0,1.75-1.75V23.35A1.76,1.76,0,0,0,42.83,22ZM29,12.54,40.15,21.6H3.29l11-9.15a1.74,1.74,0,0,0,.79.2h13.2a1.74,1.74,0,0,0,.69-.14ZM14.81,1.7a.25.25,0,0,1,.25-.25h13.2a.25.25,0,0,1,.25.25v9.2a.25.25,0,0,1-.25.25H15.06a.25.25,0,0,1-.25-.25ZM42,29.89a.25.25,0,0,1-.25.25H1.59a.25.25,0,0,1-.25-.25V23.35a.25.25,0,0,1,.25-.25H41.73a.25.25,0,0,1,.25.25Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.05,
    cy: 26.62,
    r: 1.17
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.52,
    cy: 26.62,
    r: 1.17
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.37,45.72a.75.75,0,0,1-.44-1.36c.56-.39,2-1.68,2.21-2.82a1.18,1.18,0,0,0-.24-.92,4.67,4.67,0,0,1-1.05-3.77,5.31,5.31,0,0,1,2.34-3.19A.75.75,0,0,1,16,35h0a3.77,3.77,0,0,0-1.64,2.2,3.22,3.22,0,0,0,.78,2.57,2.69,2.69,0,0,1,.52,2.05c-.31,2-2.56,3.63-2.81,3.81A.74.74,0,0,1,12.37,45.72Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.84,45.72a.75.75,0,0,1-.44-1.36c.56-.39,2-1.68,2.21-2.82a1.18,1.18,0,0,0-.24-.92,4.67,4.67,0,0,1-1.05-3.77,5.31,5.31,0,0,1,2.34-3.19.74.74,0,0,1,1,.26.75.75,0,0,1-.25,1h0a3.77,3.77,0,0,0-1.64,2.2,3.22,3.22,0,0,0,.78,2.57,2.69,2.69,0,0,1,.52,2.05c-.31,2-2.56,3.63-2.81,3.81A.74.74,0,0,1,27.84,45.72Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.84,47.86a.75.75,0,0,1-.49-1.32s3.2-2.85,2-4.8a5.76,5.76,0,0,1,1.26-8.05.75.75,0,0,1,.88,1.22,4.31,4.31,0,0,0-.87,6c1.92,3.07-2.11,6.58-2.28,6.73A.78.78,0,0,1,19.84,47.86Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExhaustFan);
export default __webpack_public_path__ + "static/media/exhaust-fan.15745cc3decca7b0ce8857b305478d5f.svg";
export { ForwardRef as ReactComponent };